const SmoothScroll = require("smooth-scroll")
const scroll = new SmoothScroll("a.scrollto", {
  offset: 120
});

document.addEventListener("turbolinks:load", function() {
  window.scrollTo(0, 0)
});

